export default {"src":"/_next/static/media/fog.ee9be4af.svg","height":145,"width":145};